export const validatePassword = (password: string) => {
  const validations = {
    hasUpperCase: /[A-Z]/.test(password),
    hasLowerCase: /[a-z]/.test(password),
    hasNumber: /\d/.test(password),
    isLengthValid: password.length >= 6 && password.length <= 10,
  };

  const isValid = validations.hasUpperCase &&
    validations.hasLowerCase &&
    validations.hasNumber &&
    validations.isLengthValid;

  const errorMessage = isValid
    ? null
    : "A senha não atende aos requisitos.";

  return { validations, errorMessage };
};

export const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
